import { useTranslations } from 'next-intl';

import { HeaderMenuLinksDesktop } from './header-menu-links-desktop';
import { HeaderMenuLinksMobile } from './header-menu-links-mobile';

const getMenuSections = (t: ReturnType<typeof useTranslations>) => [
  {
    label: t('header:links:engine'),
    items: [
      {
        label: t('header:links:engine:unity-manual'),
        href: 'https://docs.unity3d.com/Manual/',
      },
      {
        label: t('header:links:engine:scripting-api-reference'),
        href: 'https://docs.unity3d.com/ScriptReference/',
      },
      {
        label: t('header:links:engine:packages'),
        href: 'https://docs.unity3d.com/Manual/PackagesList.html',
      },
      {
        label: t('header:links:engine:multiplayer-center'),
        href: 'https://docs.unity3d.com/Manual/multiplayer.html',
      },
      {
        label: t('header:links:engine:tools'),
      },
      {
        label: t('header:links:engine:speedtree'),
        href: 'https://docs.unity3d.com/speedtree-modeler/manual/',
      },
    ],
  },
  {
    label: t('header:links:services'),
    items: [
      {
        label: t('header:links:services:accounts'),
      },
      {
        label: t('header:links:services:authentication'),
        href: '/authentication',
      },
      {
        label: t('header:links:services:cloud-save'),
        href: '/cloud-save',
      },
      {
        label: t('header:links:services:content-management'),
      },
      {
        label: t('header:links:services:cloud-code'),
        href: '/cloud-code',
      },
      {
        label: t('header:links:services:cloud-content-delivery'),
        href: '/ccd',
      },
      {
        label: t('header:links:services:economy'),
        href: '/economy',
      },
      {
        label: t('header:links:services:in-app-purchasing'),
        href: '/iap',
      },
      {
        label: t('header:links:services:remote-config'),
        href: '/remote-config',
      },
      {
        label: 'PLACEHOLDER',
      },
      {
        label: t('header:links:services:devops'),
      },
      {
        label: t('header:links:services:build-automation'),
        href: '/build-automation',
      },
      {
        label: t('header:links:services:unity-version-control'),
        href: '/unity-version-control',
      },
      {
        label: t('header:links:services:multiplayer'),
      },
      {
        label: t('header:links:services:multiplayer-center'),
        href: 'https://docs.unity3d.com/Manual/multiplayer.html',
      },
      {
        label: t('header:links:services:game-server-hosting'),
        href: '/multiplay-hosting',
      },
      {
        label: t('header:links:services:lobby'),
        href: '/lobby',
      },
      {
        label: t('header:links:services:matchmaker'),
        href: '/matchmaker',
      },
      {
        label: t('header:links:services:relay'),
        href: '/relay',
      },
      {
        label: 'PLACEHOLDER',
      },
      {
        label: t('header:links:services:player-engagement'),
      },
      {
        label: t('header:links:services:analytics'),
        href: '/analytics',
      },
      {
        label: t('header:links:services:game-overrides'),
        href: '/game-overrides',
      },
      {
        label: t('header:links:services:push-notifications'),
        href: '/push-notifications',
      },
      {
        label: t('header:links:services:community'),
      },
      {
        label: t('header:links:services:friends'),
        href: '/friends',
      },
      {
        label: t('header:links:services:leaderboards'),
        href: '/leaderboards',
      },
      {
        label: t('header:links:services:voice-text-chat'),
        href: '/vivox-unity',
      },
      {
        label: t('header:links:services:crash-reporting'),
      },
      {
        label: t('header:links:services:cloud-diagnostics'),
        href: '/cloud-diagnostics',
      },
    ],
  },
  {
    label: t('header:links:grow'),
    items: [
      {
        label: t('header:links:grow:monetize'),
      },
      {
        label: t('header:links:grow:unity-ads-monetization'),
        href: '/grow/ads',
      },
      {
        label: t('header:links:grow:ads-monetization-dashboard'),
        href: '/grow/dashboard',
      },
      {
        label: t('header:links:grow:levelplay-from-unity'),
        href: '/grow/levelplay',
      },
      {
        label: t('header:links:grow:tapjoy-from-unity'),
        href: '/grow/offerwall',
      },
      {
        label: t('header:links:grow:acquire'),
      },
      {
        label: t('header:links:grow:unity-ads-user-acquisition'),
        href: '/grow/acquire',
      },
      {
        label: t('header:links:grow:ironsource-ads-user-acquisition'),
        href: '/grow/is-ads',
      },
      {
        label: t('header:links:grow:unity-exchange'),
        href: '/grow/exchange',
      },
      {
        label: t('header:links:grow:unity-playworks'),
        href: 'https://docs.lunalabs.io',
      },
    ],
  },
  {
    label: t('header:links:industry'),
    items: [
      {
        label: t('header:links:industry:unity-asset-transformer'),
        href: 'https://pixyz-software.com/documentations/',
      },
      {
        label: t('header:links:industry:asset-manager'),
        href: '/cloud/asset-manager',
      },
      {
        label: t('header:links:industry:cloud-tools'),
        href: '/cloud/creator-sdks',
      },
      {
        label: t('header:links:industry:unity-studio'),
        href: '/unity-studio',
      },
    ],
  },
  {
    label: t('header:links:support'),
    href: 'https://unity.com/support-services',
  },
];

export interface HeaderMenuLinksProps {
  variant: 'mobile' | 'desktop';
  container?: HTMLDivElement | null;
  open?: boolean;
}

export const HeaderMenuLinks = ({ variant = 'desktop', container, open }: HeaderMenuLinksProps) => {
  const t = useTranslations();
  const menuSections = getMenuSections(t);

  if (variant === 'desktop') {
    return menuSections.map(({ label, href, items }) => {
      if (items) {
        return <HeaderMenuLinksDesktop key={label} label={label} items={items} container={container} />;
      }
      return <HeaderMenuLinksDesktop key={label} label={label} href={href} container={container} />;
    });
  }

  return <HeaderMenuLinksMobile open={open} sections={menuSections} />;
};
